import Typography from "@portal/components/atoms/v2/typography";
import { MainBox } from "../components/mainBox";
import { MapValuesToIndex, MapIndexToValues } from "../components/helpers/MapData";
import { IPageProps } from "@portal/types/robot/IPageProps";
import { RobotTextResources } from "@portal/assets/text/RobotTextResources";
import { useRobot } from "@portal/app/context/robotProvider";
import { InfoBoxComponent } from "@portal/components/atoms/infoBox";
import { SelectionBoxComponent } from "../components/selectionBox/SelectionBoxComponent";
import { RobotFooterComponent } from "../components/footer";
import { TextLine } from "@portal/components/atoms/v2/textLine";

export const SavingsPage = ({ centerId, pageIndex, isDefaultLanguage }: IPageProps) => {
  const { riskLevelRequest, setSavingsToday } = useRobot();
  const isButtonDisabled = riskLevelRequest.savingsToday === null;

  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;
  const options = [texts.PAGE_9_A, texts.PAGE_9_B, texts.PAGE_9_C];

  const OnSelectionClick = (selectedOption: number) => {
    const result = MapIndexToValues(selectedOption);
    if (result !== null) setSavingsToday(result);
  };

  return (
    <>
      <MainBox>
        <Typography variant="H6">{texts.PAGE_9_SUBHEADER}</Typography>
        <TextLine />
        <InfoBoxComponent header={texts.TEXT_QUESTION} texts={[texts.PAGE_9_INFO_BOX]} marginTop={10} />
        <SelectionBoxComponent
          options={options}
          selectedOption={MapValuesToIndex(riskLevelRequest.savingsToday) ?? -1}
          onSelectionClick={OnSelectionClick}
        />
      </MainBox>
      <RobotFooterComponent
        pageIndex={pageIndex}
        centerId={centerId}
        primaryButtonText={texts.BUTTON_NEXT}
        secondaryButtonText={texts.BUTTON_BACK}
        disabled={isButtonDisabled}
      />
    </>
  );
};
